import { find, findKey, clone, min } from 'lodash';
import moment from 'moment';

export default [
  '$window',
  'basketApiService',
  'messageService',
  'basketPopupService',
  '$timeout',
  'prompt',
  'storeService',
  (
    $window,
    basketApiService,
    messageService,
    basketPopupService,
    $timeout,
    prompt,
    storeService
  ) => {

    const basketItemByReference = (reference) => {
      for (const guest of basket.contents.guest_details) {
        const item = guest.item_details.find((item) => item.reference === reference);
        if (item) {
          return item;
        }
      }
    };

    let basket = {};

    basket.build = () => {
      basket.days = [];
      basket.treatments = [];
      basket.contents = {
        'guest_details': [],
        'voucher_details': {},
        'promo_details': {},
        'basket_status': 'checkout',
        'customer_details': {}
      };
      basket.saving = false;
      basket.success = null;
      basket.hasLoaded = false;
    };

    basket.shouldGetBasket = () => {
      if ($window.location.pathname.indexOf('/confirmation/') === -1) {
        return true;
      }

      return false;
    };

    basket.getApiBasket = () => {
      return new Promise((resolve) => {

        if (basket.shouldGetBasket()) {
          let basketId = storeService.get('basket');

          if (basketId === 'undefined' || basketId === 'null') {
            basketId = null;
            storeService.set('basket', '');
          }

          if (basketId) {
            basket.promise = basket.getExistingBasket(basketId)
              .then(() => {
                resolve();
              });
          } else {
            basket.promise = basket.getNewBasket()
              .then(() => {
                resolve();
              });
          }
        }

        resolve();
      });
    };

    basket.getExistingBasket = (basketId) => {
      basket.saving = true;
      let withItems = $window.location.pathname.indexOf('/checkout/') > -1;
      return basketApiService.retrieveBasket(basketId, withItems)
        .then(response => {
          if (response && response.guest_details) {
            basket.contents = response;
            if (basketId !== response.identity_code) {
              storeService.set('basket', response.identity_code);
            }
          }

          basket.saving = false;
          basket.hasLoaded = true;

          if(response.errors) {
            displayErrors(response.errors);
          }
        })
        .catch(error => {
          if (error.status === 410) {
            $window.location = `/confirmation/${basketId}`;
          }

          if (error.status === 400 || error.status === 404) {
            basket.errorHandler(error, 'retrieve');
            return basket.getApiBasket();
          }
        });
    };

    basket.getNewBasket = () => {
      return basketApiService.generateBasket()
        .then(response => {
          if (response && response.id && response.basket) {
            storeService.set('basket', response.id);
            basket.contents = response.basket;
          }

          basket.saving = false;
          basket.hasLoaded = true;
        })
        .catch(error => {
          basket.errorHandler(error, 'retrieve');
          $window.location = `/`;
        });
    };

    basket.addToBasket = (guests, item, showPopup = true) => {
      basket.success = null;
      basket.saving = true;
      let instanceref = basket.referenceGenerator();

      basket.contents.suggested_event = undefined;

      basket.guestSearch(guests, item, instanceref);

      basket.popup = showPopup;
      basketPopupService.remove();
      basket.setOption('delete_orders');

      return basketApiService.submitBasket(basket.contents)
        .then(response => {
          if (response.basket_status && response.basket_status !== '-1') {
            basket.contents = response;
            storeService.set('basket', response.identity_code);

            if (response.errors && response.errors.length) {
              basket.success = false;
              basket.popup = false;

              displayErrors(response.errors);
              return;
            }

            basket.success = true;
            return;
          }

          basket.popup = false;
          basket.success = false;
        })
        .catch(error => {
          basket.success = false;
          basket.popup = false;

          if (error.status === 404) {
            basket.errorHandler(error, 'retrieve');
            return basket.getApiBasket();
          }

          basket.errorHandler(error, 'add', item);
        })
        .then(() => {
          if (basket.popup) {
            basketPopupService.success(basketItemByReference(instanceref), guests, basket.contents.expires_at);
          }
          basket.saving = false;
        });
    };

    basket.removeGuestFromBasket = function (index) {
      basket.saving = true;
      basket.removeItemCheck(basket.contents.guest_details[index], 'Due to the minimum guest requirement, the following event will be removed from all guests: ')
        .then((result) => {
          basketPopupService.remove();
          if (!result) {
            basket.saving = false;
            return;
          }

          if (Array.isArray(result)) {
            for (let reference of result) {
              basket.purgeItem(reference);
            }
          }

          if (basket.contents.guest_details[index]) {
            basket.contents.guest_details.splice(index, 1);
          }

          basket.setOption('reset_steps');

          return basketApiService.submitBasket(basket.contents)
            .then(response => {
              if (response.basket_status !== '-1') {
                basket.contents = response;

                if(response.errors) {
                  displayErrors(response.errors);
                }
              }

              $timeout(() => basket.saving = false, 500);
            })
            .catch(error => {
              basket.errorHandler(error, 'guestremove');
              basket.saving = false;
            });
        });
    };

    basket.removeItemFromGuest = function (guestIndex, itemIndex) {
      basket.saving = true;
      basket.removeItemCheck(basket.contents.guest_details[guestIndex], 'Due to the minimum guest requirement, the following event will be removed from all guests: ', basket.contents.guest_details[guestIndex].item_details[itemIndex])
        .then((result) => {
          basketPopupService.remove();
          if (!result) {
            basket.saving = false;
            return;
          }

          if (Array.isArray(result)) {
            for (let reference of result) {
              basket.purgeItem(reference);
            }
          } else {
            basket.contents.guest_details[guestIndex].item_details.splice(itemIndex, 1);
          }

          basket.setOption('reset_steps');

          return basketApiService.submitBasket(basket.contents)
            .then(response => {
              if (response.basket_status !== '-1') {
                basket.contents = response;

                if(response.errors) {
                  displayErrors(response.errors);
                }
              }

              $timeout(() => basket.saving = false, 500);
            })
            .catch(error => {
              basket.errorHandler(error, 'itemremove');
              basket.saving = false;
            });
        });
    };

    basket.guestSearch = (guests, item, instanceref) => {
      if (guests.length) {
        for (let guest of guests) {
          let find = findKey(basket.contents.guest_details, basketguest =>
            (basketguest.title ? basketguest.title === guest.title : true) &&
            (basketguest.first_name ? basketguest.first_name === guest.first_name : true) &&
            (basketguest.last_name ? basketguest.last_name === guest.last_name : true)
          );

          if (guest.staff) {
            item.staff = clone(guest.staff);
          }

          if ((guest.first_name
                        || (guest.integration_reference && !guest.first_name))
                        && guest.last_name) {
            if (!find) {
              guest.item_details = [ basket.assignItem(item, instanceref) ];
              basket.contents.guest_details.push(clone(guest));
              continue;
            }

            basket.updateGuest(find, item, instanceref);
            continue;
          }

          // Throw error?
        }
      }
    };

    basket.updateGuest = (guest, item, instanceref) => {
      guest = basket.contents.guest_details[guest];
      guest.item_details = guest.item_details || [];

      let find = findKey(guest.item_details, item => item.reference === instanceref);

      if (!find) {
        guest.item_details.push(basket.assignItem(item, instanceref));
      }
    };

    basket.assignItem = (item, instanceRef = null, upgradeChildren = null) => {
      if (typeof item.price === 'object') {
        item.original_price = item.price.original_price;
        item.price = item.price.price;
      }

      let assigned = {
        'reference': instanceRef || basket.referenceGenerator(),
        'item_id': item.id,
        'name': item.name.replace('/\\/g', ''),
        'price': item.price || 0,
        'original_price': item.original_price || 0,
        'minimum_guests': item.minimum_guests || 1,
        'maximum_guests': item.maximum_guests || 1,
        'date': item.date,
        'preferred_time': item.preferred_time,
        'credit': item.credit || null,
        'currency': basket.contents.currency,
        'offer_id': item.offer,
        'upgraded': item.upgraded || 0,
        'upgrade_from_id': item.upgrade_from_id,
        'upgrade_from_name': item.upgrade_from_name,
        'upgrade_from_type': item.upgrade_from_type,
        'upgrade_from_offer': item.upgrade_from_offer,
        'upgrade_from_price': item.upgrade_from_price
      };
      if (item.staff) {
        assigned.integration_staff = item.staff.id;
        assigned.integration_staff_name = item.staff.label;
      }

      if (item.end_date_time) {
        assigned.integration_end_time = item.end_date_time;
      }

      if (item.type_name) {
        assigned.item_type = 'App\\' + item.type_name.replace(/\s/g, '');
      } else {
        assigned.item_type = 'App\\' + item.type.replace(/\s/g, '');
      }

      if (upgradeChildren) {
        assigned.item_children = upgradeChildren;
      }

      if (item.group_id) {
        assigned.item = {
          'option_group_id': item.group_id,
          'option_type': item.option_type,
          'option_id': item.option_id
        };
      }

      return assigned;
    };

    basket.changeStatus = status => { basket.contents.basket_status = status; };

    basket.referenceGenerator = () => {
      let instanceref = '';
      var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 16; i++) {
        instanceref += possible.charAt(Math.floor(Math.random() * possible.length));
      }

      return instanceref;
    };

    basket.submit = (basketOption = null, removeSaving = true) => {
      basket.success = null;
      basket.saving = true;

      if (basketOption) {
        basket.setOption(basketOption);
      }

      delete basket.contents.client_secret;

      return basketApiService.submitBasket(basket.contents)
        .then(response => {
          if (response && response.basket_status !== '-1' && response.basket_status !== 'ordered') {
            basket.contents = response;
            basket.success = true;

            if (basket.contents.errors) {
              displayErrors(basket.contents.errors);
            }
          }

          if (removeSaving) {
            $timeout(() => basket.saving = false, 500);
          }
        })
        .catch(error => {
          return basket.submitCatch(error);
        });
    };

    basket.submitCatch = (error) => {
      if (error.status === 404) {
        basket.errorHandler(error, 'retrieve');
        $window.location = `/`;
        return;
      }

      basket.errorHandler(error, 'submit');

      $timeout(() => basket.saving = false, 5000);

      $window.scrollTo(0, 280);

      return true;
    };

    basket.empty = function () {
      return (basket.contents && basket.contents.aggregate_total > 0) ? false : true;
    };

    basket.isEmpty = basket.empty();

    basket.removeItemCheck = (guest, message, item = null) => {
      let problems = [];
      let ids = [];

      if (!item) {
        for (let item of guest.item_details) {
          if (item
                        && item.item_summary
                        && item.item_summary.minimum_guests > 1
                        && item.assigned_guests - 1 < item.item_summary.minimum_guests) {
            problems.push(item.item_summary.name + ' ON ' + moment(item.date)
              .format('DD MMMM, YYYY'));
            ids.push(item.reference);
          }
        }
      } else {
        if (item
                    && item.item_summary
                    && item.item_summary.minimum_guests > 1
                    && item.assigned_guests - 1 < item.item_summary.minimum_guests) {
          problems.push(item.item_summary.name + ' ON ' + moment(item.date)
            .format('DD MMMM, YYYY'));
          ids.push(item.reference);
        }
      }

      return new Promise((resolve) => {
        if (problems.length) {
          prompt.openProblemPrompt('Confirmation', message, problems)
            .then((modal) => {
              modal.closed.then((result) => {
                switch (result) {
                case 'all':
                  resolve(ids);
                  break;

                default:
                  resolve(result);
                  break;
                }
              });
            });
        } else {
          resolve(true);
        }
      });
    };

    basket.purgeItem = (reference) => {
      for (let guest of basket.contents.guest_details) {
        let match = findKey(guest.item_details, { 'reference': reference });
        if (match) {guest.item_details.splice(match, 1);}
      }

      for (let guest in basket.contents.guest_details) {
        if (!basket.contents.guest_details[guest].item_details.length) {basket.contents.guest_details.splice(guest, 1);}
      }
    };

    basket.errorHandler = (error, type, additional = null) => {
      basket.saving = false;
      basket.hasLoaded = true;

      if (error.xhrStatus && error.xhrStatus === 'abort') {
        return false;
      }

      let errors = [];

      if (error.data) {
        if (error.data.identity_code) {
          basket.contents = error.data;
        }

        if (error.data.errors && !error.data.errors[0].includes(' ')) {
          basket.paymentErrors = error.data.errors;
          return;
        }

        if (error.data.errors) {
          errors = error.data.errors;
        }
      }

      if (!errors.length) {
        switch (type) {
        case 'retrieve':
          if (error && error.status && error.status == 410) {
            const basketId = storeService.get('basket');
            storeService.set('basket', '');

            if (basketId) {
              $window.location = `/confirmation/${basketId}`;
            }

            return;
          }

          errors.push('Sorry, your basket has expired.');
          break;

        case 'submit':
          errors.push('Sorry, something went wrong. Please try again.');
          basket.reportSentryError('Fail submitting basket', error.data);
          break;

        case 'add':
          errors.push(`Sorry, we could not add ${additional.name} to your basket.`);
          basket.popup = false;
          basket.reportSentryError('Fail adding to basket', error.data);
          break;

        case 'popupremove':
          errors.push('Sorry, we could not remove that item from your basket.');
          basket.reportSentryError('Fail removing item from basket', error.data);
          break;

        case 'create':
          errors.push('Sorry, something went wrong. Please try again.');
          basket.reportSentryError('Fail creating basket', error.data);
          break;

        case 'guestremove':
          errors.push('Sorry, we could not remove that guest.');
          basket.reportSentryError('Fail removing guest from basket', error.data);
          break;

        case 'itemremove':
          errors.push('Sorry, we could not remove that item.');
          basket.reportSentryError('Fail removing item from guest', error.data);
          break;

        default:
          errors.push('Sorry, something has gone wrong.');
        }
      }

      errors.forEach((e) => messageService.add(e));
      messageService.failure();
    };

    basket.containsCreditItems = () => {
      return !!basket.contents.has_credit;
    };

    basket.setOption = (option) => {
      basket.contents.option = option;
    };

    basket.reportSentryError = (description, extraDetails) => {
      if ($window.Sentry) {
        $window.Sentry.withScope(scope => {
          if(extraDetails) {
            Object.keys(extraDetails)
              .forEach(key => {
                scope.setExtra(key, extraDetails[key]);
              });
          }
          scope.setExtra('basketId', basket.contents.id);
          $window.Sentry.captureMessage(description);
        });
      }
    };

    basket.earliestDate = () => {
      let dates = [];
      basket.contents.guest_details.forEach(guest => {
        guest.item_details.forEach((item) => {
          dates.push(`${item.date} ${item.preferred_time}`);
        });
      });

      return min(dates);
    };

    basket.init = () => {
      basket.build();
      basket.getApiBasket();
    };

    const displayErrors = (errors) => {
      errors.forEach(error => messageService.add(error));
      messageService.failure();
    };

    basket.init();

    return basket;
  }
];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/basket/services/basket.service.js